module.exports = __webpack_public_path__ + "img/member-second-col.32064508.svg";